module.exports = __webpack_public_path__ + "static/media/Harry_Dong.6ceba80e.jpg";